import {
  Bot, MapPin, Wallet, CalendarDays, Building2, Trash2, Home, User, FileText,
  Sparkles, Target, TrendingUp, Award, Ticket, Dices, Landmark, Bell, Search,
  Flame, Clock, CheckCircle2, AlertCircle, Lightbulb, ExternalLink, Heart,
  BarChart3, Calculator, ClipboardList, Settings, Shield, Info, Coins,
  Ruler, Thermometer, Phone, Users, Ban, Accessibility, Baby, HeartHandshake,
  Building, X, MessageCircle, Rocket, Pin, Trophy, Coins as Money,
  RefreshCw, KeyRound, BookOpen, PenLine, Mail, ThumbsUp, ThumbsDown,
  Megaphone, Sparkles as Spark, CircleDot, ArrowRight, ArrowLeft, ChevronDown, ChevronUp, Circle,
  LayoutGrid, Briefcase,
} from 'lucide-react';

// 의미 기반 아이콘 매핑 — 이모지 대신 일관된 SVG를 쓰기 위한 얇은 래퍼.
// 새 아이콘이 필요하면 여기에만 추가하면 전 페이지에서 같은 이름으로 쓸 수 있다.
const MAP = {
  bot: Bot,
  location: MapPin,
  deposit: Wallet,
  rent: Coins,
  period: CalendarDays,
  households: Building2,
  complex: Building2,
  agency: Landmark,
  trash: Trash2,
  home: Home,
  apps: LayoutGrid,        // 앱 전환(런처)
  briefcase: Briefcase,    // AI공취(채용)
  user: User,
  users: Users,
  document: FileText,
  recommend: Sparkles,
  target: Target,
  trend: TrendingUp,
  score: Award,
  jubjub: Ticket,
  random: Dices,
  alarm: Bell,
  search: Search,
  hot: Flame,
  clock: Clock,
  check: CheckCircle2,
  warning: AlertCircle,
  tip: Lightbulb,
  external: ExternalLink,
  favorite: Heart,
  compare: BarChart3,
  calculator: Calculator,
  list: ClipboardList,
  settings: Settings,
  public: Building,      // 공공기관 공급 — complex(단지)와 의미가 달라 따로 둔다
  close: X,              // 모달·칩 닫기
  chat: MessageCircle,   // 챗봇
  rocket: Rocket,        // 실행·시작
  pin: Pin,              // 고정·강조
  trophy: Trophy,        // 당첨·성과
  money: Money,          // 금액
  refresh: RefreshCw,    // 새로고침·재시도
  key: KeyRound,         // 비밀번호·인증
  book: BookOpen,        // 가이드·용어
  edit: PenLine,         // 작성·수정
  mail: Mail,            // 이메일
  thumbsUp: ThumbsUp,    // 도움됨
  thumbsDown: ThumbsDown,// 도움안됨
  notice: Megaphone,     // 공지
  spark: Spark,          // 새로움·하이라이트
  dot: CircleDot,        // 상태 점
  // 텍스트 글리프를 대체하는 것들. 폰트마다 크기·정렬이 달라 크로스브라우저에서 튀던
  // `→` `▾` `▲` `●` 를 SVG 로 통일한다. 본문 속 "A → B" 같은 서술용 화살표는 그대로 둔다.
  arrowRight: ArrowRight,
  arrowLeft: ArrowLeft,
  chevronDown: ChevronDown,
  chevronUp: ChevronUp,
  circle: Circle,        // fill 과 함께 쓰면 상태 불릿
  admin: Shield,
  info: Info,
  area: Ruler,
  heating: Thermometer,
  contact: Phone,
  ban: Ban,
  disabled: Accessibility,
  child: Baby,
  couple: HeartHandshake,
};

/**
 * 의미 이름으로 lucide 아이콘을 렌더한다.
 * 장식용이므로 기본은 aria-hidden — 아이콘만으로 뜻을 전달할 때는 label을 넘길 것.
 *
 * color 기본값은 `currentColor`다. 전에는 grey600(#475569) 고정이라, 파란 배경의
 * 활성 칩이나 다크 헤더처럼 부모가 흰 글자인 자리에서 아이콘만 어두운 회색으로
 * 찍혀 대비 1.28:1 로 묻혔다. 아이콘은 라벨에 딸린 장식이므로 라벨과 같은 색이
 * 맞고, 그래야 배경이 바뀔 때마다 색을 따로 챙기지 않아도 된다.
 */
// fill 은 값이 있을 때만 넘긴다. fill={undefined} 를 그대로 주면 lucide 의 기본
// fill="none" 을 덮어써 React 가 속성을 지우고, SVG 기본값인 검정으로 칠해진다.
function Icon({ name, size = 16, color = 'currentColor', strokeWidth = 2, fill, label, style }) {
  const Cmp = MAP[name];
  if (!Cmp) return null;
  return (
    <Cmp
      size={size}
      color={color}
      strokeWidth={strokeWidth}
      {...(fill ? { fill } : {})}
      aria-hidden={label ? undefined : 'true'}
      aria-label={label}
      role={label ? 'img' : undefined}
      style={{ flexShrink: 0, verticalAlign: 'middle', ...style }}
    />
  );
}

export default Icon;
